import React, { forwardRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AppHeaderBase from './AppHeaderBase';

export {
  seccionActiva, iniciales, EnlaceHtml, ICONOS_POR_NOMBRE,
  agruparSecciones, revisarAgrupado, GRUPOS, ORDEN_GRUPOS, MAX_ENTRADAS,
  RelojEncabezado, ChipRol, formatoReloj, etiquetaRol, ETIQUETAS_ROL, ZONA_CR,
  textosConfirmarHub, TEXTOS_CONFIRMAR_HUB,
} from './AppHeaderBase';

// Encabezado común de las apps del hub (armonía visual Fase 2) para apps con
// react-router. Desde 2026-10-20 el componente vive en AppHeaderBase.jsx (sin
// react-router, para Next.js y otras) y este archivo solo le pone el Link y
// la ruta de react-router. Props, medidas y ejemplo de migración: ver
// AppHeaderBase.jsx; convención de grupos (máximo 4 entradas, Operación /
// Reportes / Gestión): README.md y agruparSecciones.js.
//
//   import AppHeader, { agruparSecciones, RelojEncabezado, ChipRol } from 'components/ui/AppHeader';
//   <AppHeader
//     titulo="Mantenimiento"
//     secciones={agruparSecciones(NAV, { sueltas: ['/'] })}
//     acciones={<><RelojEncabezado /><ChipRol rol={role} /></>}
//     ...
//   />
//
// Props propias, opcionales (para casos raros; en una app con react-router no
// hace falta pasarlas):
//   componenteEnlace  enlace interno, recibe `href`. Por defecto el Link de
//                     react-router (adaptado: Link usa `to`).
//   rutaActual        ruta para marcar la activa. Por defecto useLocation().pathname.
// Tiene que ir dentro de un <Router>. Sin router: usar AppHeaderBase.
//
// sync-ui.sh copia AppHeader.jsx, AppHeaderBase.jsx, agruparSecciones.js,
// piezasEncabezado.js y ConfirmDialog.jsx juntos (las piezas del reloj y del
// rol y el diálogo de confirmarHub viven en la base).

// El Link de react-router recibe `to`; la base pasa `href` (como next/link y <a>).
export const EnlaceRouter = forwardRef(function EnlaceRouter({ href, ...props }, ref) {
  return <Link ref={ref} to={href} {...props} />;
});

export default function AppHeader({ componenteEnlace = EnlaceRouter, rutaActual, ...props }) {
  const { pathname = '' } = useLocation() || {};
  return <AppHeaderBase {...props} componenteEnlace={componenteEnlace} rutaActual={rutaActual ?? pathname} />;
}
